import React from 'react'

// Audio
import CountdownNumSound from '../../audio/countdownNum.wav';
import Countdown0Sound from '../../audio/countdown0.wav';
import MatchSound from '../../audio/match.wav';
import WrongSound from '../../audio/wrong.wav';
import FinishedSound from '../../audio/finished.wav';

// Material UI Components
import { makeStyles, Backdrop, Box, Container, Paper, Fade, Typography, Grid, Button, Hidden, Icon, Dialog, TextField, DialogContent, DialogActions, Zoom } from '@material-ui/core';

// Material UI Custom Component Style
const useStyles = makeStyles(theme => ({
    Backdrop: {
        zIndex: '1'
    },
    Countdown: {
        height: [['100%'], '!important'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    CountdownHeader: {
        fontWeight: '500',
        fontSize: '7.5rem',
    },
    DispNone: {
        display: 'none'
    },
    Disp: {
        display: ''
    },
    Hidden: {
        visibility: 'hidden'
    },
    Visible: {
        visibility: 'visible'
    },
    Button: {
        color: theme.palette.primary.main,
        boxShadow: theme.shadows[0],
        '&:hover': {
            boxShadow: theme.shadows[0],
        }
    },
    ButtonSmall: {
        padding: theme.spacing(2.5, 1)
    },
    ButtonLarge: {
        padding: theme.spacing(4, 1)
    },
    Icon: {
        width: '100%'
    },
    Close: {
        '& span': {
            visibility: 'hidden'
        }
    },
    Open: {
        '& span': {
            visibility: 'visible'
        }
    },
    Match: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.common.white,

        '&:hover': {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.common.white,
        }
    },
    Wrong: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
        }
    },
}));

export default function Game( { cardType, gameState, volume, handleGameState, onClickEnterName, } ) {
    const Style = useStyles();

    // Audio
    const countdownNumSound = new Audio(CountdownNumSound);
    const countdown0Sound = new Audio(Countdown0Sound);
    const matchSound = new Audio(MatchSound);
    const wrongSound = new Audio(WrongSound);
    const finishedSound = new Audio(FinishedSound);

    // Volume
    countdownNumSound.volume = volume;
    countdown0Sound.volume = volume;
    matchSound.volume = volume;
    wrongSound.volume = volume;
    finishedSound.volume = volume;

    // Backdrop 
    const [openBackdrop, setOpenBackdrop] = React.useState(true);
    let [countdown, setCountdown] = React.useState(5);

    const colors = ["#3498DB", "#F39C12", "#F1C40F", "#1ABC9C", "#E74C3C", "#3498DB"];
    
    // This method will countdown to 0 then will start the game 
    const handleClickStartGame = () => {
        setOpenBackdrop(false);
        handleClickDialogOpen("Countdown");

        let colorIndex = 0;

        setTimeout(() => {
            handleGameState("Started");
        }, 750);
        
        const interval = setInterval(() => {
            countdownNumSound.play();

            setTimeout(() => {
                countdownNumSound.currentTime = 0;
            }, 750);
            
            setCountdown(--countdown);
            colorIndex = ++colorIndex;
            
            if(countdown <= 0){
                setTimeout(() => {
                    countdownNumSound.pause();
                    countdownNumSound.currentTime = 0;
                }, 750);
                
                setTimeout(() => {
                    countdown0Sound.play();
                }, 400);

                clearInterval(interval);
                setTimeout(() => {
                    handleDialogClose()
                }, 750);
            }
        }, 1000); 
    }

    // Game
    let openCards = [];
    let matchedCards = [];

    const iconsArray = (cardType === null) 
        ? [
            "fa-cat", "fa-cat",
            "fa-dog", "fa-dog",
            "fa-hippo", "fa-hippo",
            "fa-fish", "fa-fish",
            "fa-horse", "fa-horse",
            "fa-dove", "fa-dove",
            "fa-frog", "fa-frog",
            "fa-crow", "fa-crow"
        ]
            : cardType.icons;

    // This method shuffles the icons
    const shuffle = (iconArray) => {
        let currentIndex = iconArray.length, temporaryValue, randomIndex;

        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            temporaryValue = iconArray[currentIndex];
            iconArray[currentIndex] = iconArray[randomIndex];
            iconArray[randomIndex] = temporaryValue;
        }
        return iconArray;
    }

    /* 
        This method will handle whenever the user clicks on a card
    */
    const handleIconClick = (event, index, icon) => {
        event.preventDefault();

        matchSound.pause();
        matchSound.currentTime = 0;
        wrongSound.pause();
        wrongSound.currentTime = 0;

        if(openCards.length <= 1){
            const allCards = document.querySelectorAll(".Card");
            const currentCard = allCards[index - 1];
            const currentCardButton = currentCard.firstChild;
            const currentCardButtonClassList = currentCardButton.classList;
            
            if((!currentCardButtonClassList.contains(Style.Open)) && (!currentCardButtonClassList.contains(Style.Match))){
                currentCardButton.classList.remove(Style.Close)
                currentCardButton.classList.add(Style.Open);
                openCards.push(currentCard);

                if(openCards.length > 1){
                    const otherCard = openCards[0];
                    const otherCardButton = otherCard.firstChild;
                    const otherCardIconParent = otherCardButton.firstChild;
                    const otherCardIcon = otherCardIconParent.firstChild;
                    const otherCardIconClassList = otherCardIcon.classList;

                    if(otherCardIconClassList.contains(icon)){
                        matchSound.play();
                        matchSound.playbackRate = 1.5;

                        currentCardButton.classList.add(Style.Match);
                        otherCardButton.classList.add(Style.Match);

                        matchedCards.push(otherCardButton);
                        matchedCards.push(currentCardButton);
                        openCards = [];
                    }else{
                        wrongSound.play();
                        wrongSound.playbackRate = 1.5;

                        currentCardButton.classList.add(Style.Wrong);
                        otherCardButton.classList.add(Style.Wrong);

                        setTimeout(() => {
                                currentCardButton.classList.remove(Style.Open, Style.Wrong);
                                otherCardButton.classList.remove(Style.Open, Style.Wrong);
                                currentCardButton.classList.add(Style.Close);
                                otherCardButton.classList.add(Style.Close);

                                openCards = [];
                        }, 500);
                    }
                }
            }
        }else{
            return
        }
    }

    React.useEffect(() => {
        let interval;
        
        switch(gameState){
            case "":
                setCountdown(5);
                clearInterval(interval);

                break;
            case "Started":
                interval = setInterval(() => {
                    if(matchedCards.length === 16){
                        finishedSound.play();
                        finishedSound.playbackRate = 1.5;

                        clearInterval(interval);
                        handleGameState("Stopped");
                        handleClickDialogOpen("Name");
                    }
                }, 500);

                break;
            default:
                break;
        }

        return () => clearInterval(interval);
    }, [matchedCards, handleGameState, gameState, finishedSound]);

    // Dialog
    const [openDialog, setOpenDialog] = React.useState(false);
    const [dialogType, setDialogType] = React.useState(null);
    const [name, setName] = React.useState('');

    // This method will handle the name if the user types a name that is longer than 18 characters long a message will display
    const handleNameMaxLength = (event) => {
        if(name.length > 18){
            if(event.key === "Backspace" || event.key === "Delete"){
                setName("");
                event.target.value = "";
            }else{
                event.target.value = "Limit of 18 Characters reached.";
                return
            }
        }else{
            return
        }
    }

    // This method will open the dialog and set the dialog content to the type
    const handleClickDialogOpen = (type) => {
        setOpenDialog(true);
        setDialogType(type);
    };
    
    // This method will close the dialog 
    const handleDialogClose = (type) => {
        setOpenDialog(false);
        if(type === "Name"){
            setName("");
            handleGameState("");
            setOpenBackdrop(true);
        }
    };

    return (
        <React.Fragment>
            <Backdrop className={Style.Backdrop} open={openBackdrop}>
                <Paper variant="outlined">
                    <Box p={6}>
                        <Button aria-label="Start" color="primary" size="large" variant="contained" onClick={() => handleClickStartGame()}>Start Game</Button>
                    </Box>
                </Paper>
            </Backdrop>
            <Fade in={openBackdrop === true ? false : true} timeout={2000} >
                <Box className={openBackdrop === true ? Style.Hidden : Style.Visible} m={2}>
                    <Container maxWidth="sm" disableGutters>
                        <Grid container spacing={1} variant="outlined" alignContent="center" alignItems="center">
                            {
                                shuffle(iconsArray).map((i, index) => {
                                    return(
                                        <Grid className="Card" key={Math.random()} item xs={3}>
                                                <Hidden smUp>
                                                    <Button className={`${Style.Button} ${Style.ButtonSmall} ${Style.Close}`} variant="contained" size="large" fullWidth onMouseDown={(event) => handleIconClick(event, index + 1, i)}>
                                                        <Icon 
                                                            className={
                                                                cardType === null
                                                                    ? `fas ${i} ${Style.Icon}`
                                                                        : cardType.title === "Brands"
                                                                            ? `fab ${i} ${Style.Icon}`
                                                                                : `fas ${i} ${Style.Icon}`
                                                            } 
                                                            style={{fontSize: '2.25rem'}}></Icon>
                                                    </Button>
                                                </Hidden>
                                                <Hidden xsDown>
                                                    <Button className={`${Style.Button} ${Style.ButtonLarge} ${Style.Close}`} variant="contained" size="large" fullWidth onMouseDown={(event) => handleIconClick(event, index + 1, i)}> 
                                                        <Icon 
                                                            className={
                                                                cardType === null
                                                                    ? `fas ${i} ${Style.Icon}`
                                                                        : cardType.title === "Brands"
                                                                            ? `fab ${i} ${Style.Icon}`
                                                                                : `fas ${i} ${Style.Icon}`
                                                            } 
                                                            style={{fontSize: '3.375rem'}}>
                                                        </Icon>
                                                    </Button>
                                                </Hidden>
                                        </Grid>
                                    );
                                })
                            } 
                        </Grid>
                    </Container>
                </Box>
            </Fade>
            <Dialog
                open={openDialog}
                fullScreen={dialogType === "Name" ? false : true}
                aria-labelledby="dialogTitle"
                TransitionComponent={Fade}
                transitionDuration={1000}
            >
                {
                    dialogType === "Name"
                        ?
                        <React.Fragment>
                            <DialogContent style={{maxHeight: '500px'}}>
                                <Typography color="secondary" variant="h6">Congratulations</Typography>
                                <Typography color="textPrimary" variant="body1">You have set a new time</Typography>
                                <Box pt={2} />
                                <TextField
                                    margin="dense"
                                    id="name"
                                    label="Enter Name"
                                    type="text"
                                    onChange={(event) => setName(event.target.value)}
                                    onKeyDown={(event) => handleNameMaxLength(event)}
                                    value={name}
                                    placeholder='Try "John"'
                                    variant="outlined"
                                    fullWidth
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => handleDialogClose("Name")} color="inherit">
                                    Cancel
                                </Button>
                                <Button onClick={() => {handleDialogClose("Name"); onClickEnterName(name);}} color="primary">
                                    Submit
                                </Button>
                            </DialogActions>
                        </React.Fragment>
                            : dialogType === "Countdown"
                                ?
                                <DialogContent className={Style.Countdown}>
                                    {
                                        colors.map((color, index) => {
                                            return(
                                                <Zoom key={index} in={countdown === (-1*(index-5)) ? true : false} timeout={1000}>
                                                    <Typography          
                                                        className={`${Style.CountdownHeader} ${countdown === (-1*(index-5)) ? Style.Disp : Style.DispNone}`} 
                                                        variant="h1" style={{color: color}} >{countdown === 0 ? "GO" : countdown}
                                                    </Typography>
                                                </Zoom>
                                            );
                                        })
                                    }
                                </DialogContent>
                                    : ""
                }
            </Dialog>
        </React.Fragment>
    )
}